import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import Pagination from "../Pagination/Paginations";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const MonthlyOvertimeReport = () => {
  const today = new Date().toISOString().split("T")[0];

  const [filters, setFilters] = useState({
    start_date: today,
    end_date: today,
    dept_id: "0",
    overtime_status: "2",
  });

  const [departments, setDepartments] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  /* ================= INPUT ================= */
  const handleInput = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  /* ================= DEPARTMENTS ================= */
  const fetchDepartments = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/showdepartment", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      setDepartments(res.data?.departments || res.data?.data || res.data || []);
    } catch {
      toast.error("Failed to load departments");
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  /* ================= FETCH REPORT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    // block repeat clicks while a request is already running
    if (loadingRef.current) return;
    loadingRef.current = true;
    setLoading(true);
    try {
      const res = await axios.post(
        API_BASE_URL + "/monthly_overtime_report",
        filters,
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );

      setRecords(res.data.records || []);
      toast.success("Monthly OT Report loaded successfully!", {
        position: "bottom-right",
        theme: "colored",
        toastId: "monthly-overtime-success",
      });
    } catch {
      toast.error("Error fetching monthly overtime report", { toastId: "monthly-overtime-error" });
    } finally {
      loadingRef.current = false;
      setLoading(false);
    }
  };

  /* ================= SEARCH ================= */
  const filteredRecordsAll = records.filter((item) =>
    `${item.employee_id} ${item.employee_name} ${item.department} ${item.no_of_hour} ${item.amount}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  /* Pagination (Previous / Next style) */
  const totalPages = Math.ceil(filteredRecordsAll.length / perPage);
  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;
  const filteredRecords = filteredRecordsAll.slice(indexOfFirst, indexOfLast);

  /* ================= COLUMNS ================= */
  const columns = [
    { name: "Employee ID", selector: r => r.employee_id, sortable: true },
    { name: "Employee Name", selector: r => r.employee_name, sortable: true },
    { name: "Department", selector: r => r.department, sortable: true },
    { name: "No of Hours", selector: r => r.no_of_hour, sortable: true, right: true },
    { name: "Calc Point", selector: r => r.calc_point, sortable: true, right: true },
    { name: "Amount", selector: r => r.amount, sortable: true, right: true },
    
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f8f9fa",
        fontWeight: "bold",
      },
    },
  };

  return (
    <div className="container-fluid mt-4">

      {/* ================= FILTER ================= */}
      <div className="card shadow-sm mb-4">
        <h6 className="card-header d-flex align-items-center" style={{ color: "#1d3a8a", fontWeight: 600 }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
            <path fillRule="evenodd" d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.017-1.694a.5.5 0 1 1 .858.257z"/>
            <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
            <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
          </svg>
          Monthly Overtime Summary
        </h6>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3 align-items-end">

             <div className="col-md">
  <label>From Date</label>

  <DatePicker
    selected={filters.start_date ? new Date(filters.start_date) : null}
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString("en-CA")
        : "";

      setFilters((prev) => ({
        ...prev,
        start_date: value,
      }));
    }}
    dateFormat="yyyy-MM-dd"
    placeholderText="Select From Date"
    className="form-control"
    maxDate={filters.end_date ? new Date(filters.end_date) : null}
  />
</div>

<div className="col-md">
  <label>To Date</label>

  <DatePicker
    selected={filters.end_date ? new Date(filters.end_date) : null}
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString("en-CA")
        : "";

      setFilters((prev) => ({
        ...prev,
        end_date: value,
      }));
    }}
    dateFormat="yyyy-MM-dd"
    placeholderText="Select To Date"
    className="form-control"
    minDate={filters.start_date ? new Date(filters.start_date) : null}
  />
</div>


              <div className="col-md">
                <label>Department</label>
                <Select
                  options={departments.map(d => ({
                    value: d.department_id || d.id,
                    label: d.department_name,
                  }))}
                  isClearable
                  placeholder="All Department"
                  value={departments
                    .map(d => ({
                      value: d.department_id || d.id,
                      label: d.department_name,
                    }))
                    .find(o => o.value === filters.dept_id) || null}
                  onChange={(opt) =>
                    handleInput({
                      target: {
                        name: "dept_id",
                        value: opt ? opt.value : "0",
                      },
                    })
                  }
                />
              </div>

              <div className="col-md">
                <label>Status</label>
                <select className="form-control"
                  style={{ height: "38px" }}
                  name="overtime_status"
                  value={filters.overtime_status}
                  onChange={handleInput}>
                  <option value="2">Approved</option>
                  <option value="3">Rejected</option>
                </select>
              </div>

              <div className="col-md-auto">
                <button type="submit" className="btn btn-primary btn-sm" style={{ height: "38px" }} disabled={loading}>{loading ? "Loading..." : "Get"}</button>
              </div>

            </div>
          </form>
        </div>
      </div>

      {/* ================= TABLE ================= */}
      <div className="card">
        <div className="card-body">

          <div className="d-flex justify-content-between mb-3">
            <DownloadButtons
              data={filteredRecordsAll}
              filename="Monthly_OT_Report"
            />

            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
              <EntriesSelector
                entriesPerPage={perPage}
                setEntriesPerPage={setPerPage}
                setCurrentPage={setCurrentPage}
              />
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search..."
                style={{ width: "220px" }}
                value={searchTerm}
                onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
              />
            </div>
          </div>

          <DataTable
            columns={columns}
            data={filteredRecords}
            progressPending={loading}
            striped
            highlightOnHover
            dense
            customStyles={customStyles}
            noDataComponent={
              <div className="p-3 text-danger fw-bold">
                No records found
              </div>
            }
          />

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default MonthlyOvertimeReport;
